export default __webpack_public_path__ + "static/media/uslugiWhite.bd5ed7f5.svg";